import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
import history from "../../../router/browserrouter";

export default function* watcherSaveOrderSaga() {
  yield takeEvery("SAVE_ORDERS", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER", payload: payload });
    var payload = {};
    formatUrl = "api/SalesTransactionV2/save-order";
    yield request("post", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    var formatUrl = `get-sales-order-details`;
    yield request("get", payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "ORDERS_LIST", payload: payload });
    yield put({ type: "CLEAR_CART"});
    toast.success("Successful")
    yield put({ type: "DISPLAY_LOADER", payload: payload });
    history.push("/orders");
  } catch (e) {
    console.log(e);
    console.log("product-saga", e);
    console.log("product-saga", e.response);
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
    yield put({ type: "DISPLAY_LOADER", payload: payload });
  }
}
